import { Exclude, Expose } from "class-transformer";
import { IsBoolean, IsDefined, IsInt, IsUUID } from "class-validator";

@Exclude()
export class UpsellRoute {
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public routeId: string;

    @IsBoolean()
    @Expose()
    public isOtherDirection?: boolean;

    @IsInt()
    @IsDefined()
    @Expose()
    public order: number;

    @IsBoolean()
    @Expose()
    public isToOrigin?: boolean; // is from destination when false
}
